// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chip-status-no-truncate {\n  height: auto !important;\n  min-height: 24px !important;\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n.chip-status-no-truncate .v-chip__content {\n  white-space: normal !important;\n  word-break: break-word;\n  align-items: center;\n}\n.chip-status-text-wrap {\n  white-space: normal !important;\n  word-break: break-word;\n  max-width: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
